import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import shape from "../../images/ft-shape.png";
import { getBusinessSettings } from "../../api/getBusinessSettings";
import { getServices } from "../../api/service";
import {
  FaTelegramPlane,
  FaLinkedin,
  FaClock,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

const ClickHandler = () => {
  window.scrollTo({
    top: 0, // scroll to the top
    left: 10, // horizontal scroll (you can set 0 if not needed)
    behavior: "smooth", // enables smooth scrolling
  });
};

const Footer = (props) => {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    getBusinessSettings().then(setSettings);
  }, []);

  useEffect(() => {
    getServices().then(setServices);
  }, []);

  if (!settings || services.length === 0) {
    return null;
  }

  return (
    <footer className="wpo-site-footer-s2">
      <div
        className="wpo-upper-footer"
        style={{
          paddingTop: "30px",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img
                    src={`${apiUrl}/storage/` + settings.logo}
                    alt="logo"
                    style={{
                      width: "110px",
                      height: "70px",
                      display: "block",
                      margin: "auto",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                      borderRadius: "5px",
                    }}
                  />
                </div>
                <p
                  style={{
                    textAlign: "justify",
                  }}
                >
                  Star Family Industrial PLC blends tradition and innovation to
                  deliver quality products and trusted export services.
                </p>
                <ul
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    width: "100%",
                    marginRight: "20px",
                  }}
                >
                  {settings.facebookLink && (
                    <li
                      style={{
                        flexShrink: 0,
                        width: "18px",
                      }}
                    >
                      <a
                        href={settings.facebookLink}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "14px",
                        }}
                      >
                        <i className="ti-facebook"></i>
                      </a>
                    </li>
                  )}
                  {settings.twitterLink && (
                    <li
                      style={{
                        flexShrink: 0,
                        width: "18px",
                      }}
                    >
                      <a
                        href={settings.twitterLink}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "14px",
                        }}
                      >
                        <i className="ti-twitter-alt"></i>
                      </a>
                    </li>
                  )}
                  {settings.instagramLink && (
                    <li
                      style={{
                        flexShrink: 0,
                        width: "18px",
                      }}
                    >
                      <a
                        href={settings.instagramLink}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "14px",
                        }}
                      >
                        <i className="ti-instagram"></i>
                      </a>
                    </li>
                  )}
                  {settings.tiktokLink && (
                    <li
                      style={{
                        flexShrink: 0,
                        width: "18px",
                      }}
                    >
                      <a
                        href={settings.tiktokLink}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "14px",
                        }}
                      >
                        <SiTiktok />
                      </a>
                    </li>
                  )}
                  {settings.telegramLink && (
                    <li
                      style={{
                        flexShrink: 0,
                        width: "18px",
                      }}
                    >
                      <a
                        href={settings.telegramLink}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "14px",
                        }}
                      >
                        <FaTelegramPlane />
                      </a>
                    </li>
                  )}
                  {settings.linkedInLink && (
                    <li
                      style={{
                        flexShrink: 0,
                        width: "18px",
                      }}
                    >
                      <a
                        href={settings.linkedInLink}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "14px",
                        }}
                      >
                        <FaLinkedin />
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3 style={{ color: "gray", fontWeight: "bold" }}>
                    Our Services
                  </h3>
                </div>
                <ul>
                  {services.slice(0, 4).map((service, index, arr) => (
                    <li key={service.id}>
                      <Link
                        onClick={ClickHandler}
                        to={`/service-single/${service.id}`}
                      >
                        {service.serviceName.length > 50
                          ? service.serviceName.slice(0, 50) + "..."
                          : service.serviceName}
                      </Link>
                      {index === arr.length - 1 && services.length > 4
                        ? " ..."
                        : ""}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget blog-widget">
                <div className="widget-title">
                  <h3 style={{ color: "gray", fontWeight: "bold" }}>
                    Quick Links
                  </h3>
                </div>
                <ul>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/">
                        Home
                      </Link>
                    </h4>
                  </li>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/about">
                        About Us
                      </Link>
                    </h4>
                  </li>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/team">
                        Team
                      </Link>
                    </h4>
                  </li>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/service">
                        Services
                      </Link>
                    </h4>
                  </li>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/product">
                        Products
                      </Link>
                    </h4>
                  </li>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/project">
                        Projects
                      </Link>
                    </h4>
                  </li>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/event">
                        Events
                      </Link>
                    </h4>
                  </li>
                  <li
                    style={{
                      height: "4px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px" }}>
                      <Link onClick={ClickHandler} to="/contact">
                        Contact Us
                      </Link>
                    </h4>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget newsletter-widget">
                <div className="widget-title">
                  <h3 style={{ color: "gray", fontWeight: "bold" }}>
                    Contact Us
                  </h3>
                </div>
                <ul
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <li
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                      color: "gray",
                    }}
                  >
                    <FaClock style={{ width: "20px", height: "20px" }} />
                    <Link
                      style={{ color: "gray", fontSize: "14px" }}
                      onClick={ClickHandler}
                      to="/"
                    >
                      Open Hours |:| Mon - Fri |:| 8:00AM - 6:00PM.
                    </Link>
                  </li>
                  <li
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                      color: "gray",
                    }}
                  >
                    <FaMapMarkerAlt style={{ width: "20px", height: "20px" }} />
                    <Link
                      style={{ color: "gray", fontSize: "14px" }}
                      onClick={ClickHandler}
                      to="/"
                    >
                      {settings.address}
                    </Link>
                  </li>
                  <li
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                      color: "gray",
                    }}
                  >
                    <FaPhoneAlt style={{ width: "20px", height: "20px" }} />
                    <Link
                      style={{ color: "gray", fontSize: "14px" }}
                      onClick={ClickHandler}
                      to="/"
                    >
                      {settings.phone1}
                    </Link>
                  </li>
                  <li
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                      color: "gray",
                    }}
                  >
                    <FaEnvelope style={{ width: "20px", height: "20px" }} />
                    <Link
                      style={{ color: "gray", fontSize: "14px" }}
                      onClick={ClickHandler}
                      to="/"
                    >
                      {settings.email}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="ft-shape">
          <img src={shape} alt="shape" />
        </div>
        <div className="ft-shape-s1">
          <svg
            width="254.000000pt"
            height="257.000000pt"
            viewBox="0 0 254.000000 257.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <defs>
              <linearGradient
                id="footerGradient1"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop offset="0%" stopColor="#001a4d" />
                <stop offset="100%" stopColor="#66b2ff" />
              </linearGradient>
            </defs>
            <g
              transform="translate(0.000000,257.000000) scale(0.100000,-0.100000)"
              stroke="none"
              fill="url(#footerGradient1)"
            >
              <path d="M0 1341 c0 -1111 2 -1229 16 -1235 8 -3 56 -11 104 -16 206 -23 368 38 504 191 26 30 135 185 241 344 217 326 264 388 403 529 159 162 348 309 592 461 179 112 349 228 405 277 72 63 132 151 156 226 16 54 20 93 20 202 1 80 -5 157 -13 190 l-13 55 -1208 3 -1207 2 0 -1229z" />
            </g>
          </svg>
        </div>
        <div className="ft-shape-s2">
          <svg
            width="230.000000pt"
            height="197.000000pt"
            viewBox="0 0 230.000000 197.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <defs>
              <linearGradient
                id="footerGradient2"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop offset="0%" stopColor="#001a4d" />
                <stop offset="100%" stopColor="#66b2ff" />
              </linearGradient>
            </defs>
            <g
              transform="translate(0.000000,197.000000) scale(0.100000,-0.100000)"
              stroke="none"
              fill="url(#footerGradient2)"
            >
              <path d="M1885 1463 c-189 -11 -392 -50 -565 -109 -202 -68 -460 -209 -630 -345 -222 -176 -436 -441 -560 -694 -45 -91 -120 -283 -120 -305 0 -6 428 -10 1145 -10 l1145 0 0 719 c0 677 -1 720 -17 725 -25 8 -268 26 -312 24 -20 -1 -58 -3 -86 -5z" />
            </g>
          </svg>
        </div>
      </div>
      <div
        className="wpo-lower-footer"
        style={{
          backgroundColor: "#0d0d0d",
          color: "white",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col col-lg-6 col-md-12 col-12"
              style={{
                width: "100%",
              }}
            >
              <ul
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <li>
                  Copyright &copy; 2025{" "}
                  <Link onClick={ClickHandler} to="/">
                    StarFamily Industrial PLC
                  </Link>{" "}
                  All Right Reserved - Powered by{" "}
                  <Link
                    onClick={ClickHandler}
                    to="https://keradiontechnology.com/"
                  >
                    Keradion Technology
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
